import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {GraphQLService} from "../graphql.service";
import {TranslationBundle} from "../../models/vouchers/translation_bundle.model";

@Injectable()
export class TranslationBundleService extends GraphQLService<TranslationBundle> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar);
  }

  byCode(code: string) {
    const productDetail = 'id internalId priceNetto currencyPrices { currency exchangeRate netPrice } productBook { title language subtitle blurb isbn hardcover numpages publishedAt publisher { name url } }'
    return this.find(`{ translationBundle(code: "${code}") { code validUntil original { ${productDetail} } translations { ${productDetail} } discount { percentage } } }`)
  }

}
